import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';

import { VirtualRoomRouterStoreSelectors } from '@era/stores';
import * as fromLight from './lights.reducer';

export interface LightState {
  lights: fromLight.LightState;
}

export const reducers: ActionReducerMap<LightState> = {
  lights: fromLight.lightReducer,
};

export const selectLightState = createFeatureSelector<fromLight.LightState>(fromLight.inRoomLightFeatureKey);

export const selectLightIds = createSelector(selectLightState, fromLight.selectLightIds);

export const selectLightEntities = createSelector(selectLightState, fromLight.selectLightEntities);

export const selectAllLights = createSelector(selectLightState, fromLight.selectAllLights);

export const selectLightTotal = createSelector(selectLightState, fromLight.selectLightsTotal);

export const getLight = (location: string, room: string, code: string) =>
  createSelector(selectLightEntities, (entities) => entities[fromLight.selectLightId(location, room, code)]);

export const selectCurrentLights = createSelector(
  selectAllLights,
  VirtualRoomRouterStoreSelectors.selectLocation,
  VirtualRoomRouterStoreSelectors.selectRoom,
  (lights, location, room) => {
    return lights.filter((light) => light.HotelCode === location && light.Room === room);
  }
);
